import { Component } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { DividerModule } from "primeng/divider";
import { ChipsModule } from "primeng/chips";
import { CommonModule } from "@angular/common";
import { Store } from "@ngrx/store";
import {
  FeatureState,
  selectFeatureStateForm,
  ToggleFeatureActions,
} from "../../../../store";
import { Observable } from "rxjs";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {PopoverModule} from 'primeng/popover';
import { ToggleSwitchModule, ToggleSwitchChangeEvent } from 'primeng/toggleswitch';

@Component({
  selector: "app-toggle-feature",
  templateUrl: "./toggle-feature.component.html",
  styleUrls: ["./toggle-feature.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    ChipsModule,
    ToggleSwitchModule,
    ReactiveFormsModule,
    FormsModule,
    DividerModule,
    PopoverModule
  ],
})
export class ToggleFeatureComponent {
  public readonly toggleFeatureSelect$: Observable<FeatureState>;

  constructor(private readonly store: Store) {
    this.toggleFeatureSelect$ = this.store.select(selectFeatureStateForm);
  }

  updateAllItems(event: any) {
    this.store.dispatch(ToggleFeatureActions.updateAllItems({ checked: event.checked }));
  }

  updateDevelopmentItems(event: ToggleSwitchChangeEvent) {
    this.store.dispatch(ToggleFeatureActions.updateDevelopmentItems({ checked: event.checked }));
  }

}
